const translations = {
    exemptionDocketNumberErrorMessage: 'Invalid Exemption Docket Number. Example: FAA-1234-5678',
    maxExceededErrorMessage: 'Too many characters',
    requiredErrorMessage: 'This field is required'
};

export default translations;
